<template>
    <chart id="opt" :options="opt" />
</template>

<script>

  import ECharts from "vue-echarts";
  import ecStat from "echarts-stat";
  import "echarts/lib/chart/line";
  import "echarts/lib/chart/scatter";
  import "echarts/lib/component/markPoint";

  export default {
    name: "a4",
    props: {},
    components: { chart: ECharts, ecStat },
    data() {
      return {
        opt: {}
      };
    },
    created() {
      var data = [
        [1, 4862.4],
        [2, 5294.7],
        [3, 5934.5],
        [4, 7171.0],
        [5, 8964.4],
        [6, 10202.2],
        [7, 11962.5],
        [8, 14928.3],
        [9, 16909.2],
        [10, 18547.9],
        [11, 21617.8],
        [12, 26638.1],
        [13, 34634.4],
        [14, 46759.4],
        [15, 58478.1],
        [16, 67884.6],
        [17, 74462.6],
        [18, 79395.7]
      ];
      var data2 = [
        [1, 42.4],
        [2, 52],
        [3, 5934.5],
        [4, 771.0],
        [5, 4.4],
        [6, 102.2],
        [7, 162.5],
        [8, 1498.3],
        [9, 1699.2],
        [10, 147.9],
        [11, 2117.8],
        [12, 238.1],
        [13, 334.4],
        [14, 46759.4],
        [15, 58478.1],
        [16, 6786],
        [17, 742.6],
        [18, 795.7]
      ];
      var data3 = [
        [1, 2342.4],
        [2, 52232],
        [3, 5934.5],
        [4, 7231.0],
        [5, 34.54],
        [6, 1202.2],
        [7, 1632.5],
        [8, 14598.3],
        [9, 1699.2],
        [10, 15547.9],
        [11, 2117.8],
        [12, 338.1],
        [13, 33534.4],
        [14, 46759.4],
        [15, 58478.1],
        [16, 3586],
        [17, 72342.6],
        [18, 7595.7]
      ];
      var data4 = [
        [1, 22.4],
        [2, 532],
        [3, 534.5],
        [4, 721.0],
        [5, 34.54],
        [6, 1202.2],
        [7, 1632.5],
        [8, 1459],
        [9, 1699.2],
        [10, 5547.9],
        [11, 2117.8],
        [12, 338.1],
        [13, 3354.4],
        [14, 46759],
        [15, 5878.1],
        [16, 3586],
        [17, 7232.6],
        [18, 595.7]
      ];
      var data5 = [
        [1, 23142.4],
        [1, 23542.4],
        [1, 33142.4],
        [1, 23342.4],
        [1, 23148],
        [2, 52232],
        [3, 59234.5],
        [4, 7231.0],
        [5, 3425.54],
        [6, 1202.2],
        [7, 16232.5],
        [7, 13232.5],
        [7, 16282.5],
        [7, 6232.5],
        [7, 16632.5],
        [7, 46232.5],
        [8, 16598.3],
        [9, 16399.2],
        [10, 15547.9],
        [11, 23117.8],
        [12, 338.1],
        [13, 33534.4],
        [14, 46759.4],
        [15, 58478.1],
        [16, 35866],
        [17, 72342.6],
        [18, 75295.7]
      ];

      var myRegression = ecStat.regression("exponential", data);
      var myRegression2 = ecStat.regression("exponential", data2);
      var myRegression3 = ecStat.regression("exponential", data3);
      var myRegression4 = ecStat.regression("exponential", data4);
      var myRegression5 = ecStat.regression("exponential", data5);

      myRegression.points.sort(function(a, b) {
        return a[0] - b[0];
      });
      myRegression2.points.sort(function(a, b) {
        return a[0] - b[0];
      });
      myRegression3.points.sort(function(a, b) {
        return a[0] - b[0];
      });
      myRegression4.points.sort(function(a, b) {
        return a[0] - b[0];
      });
      myRegression5.points.sort(function(a, b) {
        return a[0] - b[0];
      });

      this.opt = {
        title: {
          show: false
        },
        grid: [
          {
            bottom: "55%"
          },
          {
            top: "55%"
          }
        ],
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross"
          }
        },
        xAxis: [
          {
            type: "value",
            splitLine: {
              show: false
            }
          },
          {
            type: "value",
            gridIndex: 1,
            splitLine: {
              show: false
            }
          }
        ],
        yAxis: [
          {
            type: "value"
          },
          {
            type: "value",
            gridIndex: 1
          }
        ],
        series: [
          {
            name: "scatter",
            type: "scatter",
            color: ["#4f83be"],
            symbol: "path://M512 69.479l442.498 442.498-442.498 442.498-442.498-442.498 442.498-442.498z",
            label: {
              emphasis: {
                show: true
              }
            },
            data: data
          },
          {
            name: "scatter",
            type: "scatter",
            color: ["#bcbac0"],
            symbol: "path://M899.499963 262.219143 759.090073 121.815393 513.401418 367.506095 267.714809 121.815393 127.310036 262.22426 373.000737 507.910868 127.314129 753.5985 267.712763 893.996111 513.401418 648.307456 759.095189 893.998157 899.488707 753.5985 653.804145 507.910868Z",
            label: {
              emphasis: {
                show: true
              }
            },
            data: data2
          },
          {
            name: "scatter",
            type: "scatter",
            color: ["#8db3b3"],
            symbol: "path://M821.1 595c14.6 8.2 24 20.5 28.3 36.8s2.3 31.8-5.9 46.4L813 730.5c-8.2 14.6-20.5 24-36.8 28.3s-31.8 2.3-46.4-5.9l-126.5-72.7v146c0 16.5-6 30.7-18.1 42.8-12.1 12-26.3 18.1-42.8 18.1h-60.9c-16.5 0-30.7-6-42.8-18.1-12-12-18.1-26.3-18.1-42.8v-146l-126.5 72.7c-14.6 8.2-30 10.2-46.4 5.9-16.3-4.3-28.6-13.7-36.8-28.3l-30.4-52.3c-8.2-14.6-10.2-30-5.9-46.4 4.3-16.3 13.7-28.6 28.3-36.8l126.5-73.2-126.5-73.2c-14.6-8.2-24-20.5-28.3-36.8s-2.3-31.8 5.9-46.4L211 313c8.2-14.6 20.5-24 36.8-28.3s31.8-2.3 46.4 5.9l126.5 72.7v-146c0-16.5 6-30.7 18.1-42.8 12-12 26.3-18.1 42.8-18.1h60.9c16.5 0 30.7 6 42.8 18.1 12 12.1 18.1 26.3 18.1 42.8v146l126.5-72.7c14.6-8.2 30-10.2 46.4-5.9 16.3 4.3 28.6 13.7 36.8 28.3l30.4 52.3c8.2 14.6 10.2 30 5.9 46.4-4.3 16.3-13.7 28.6-28.3 36.8l-126.5 73.2L821.1 595z",
            label: {
              emphasis: {
                show: true
              }
            },
            data: data3
          },
          {
            name: "line",
            type: "line",
            showSymbol: false,
            smooth: true,
            data: myRegression.points,
            color: ["#5e85a8"],
            markPoint: {
              symbol: "circle",
              symbolSize: 1,
              label: {
                show: true,
                position: "left",
                formatter: myRegression.expression,
                textStyle: {
                  color: "#333",
                  fontSize: 14
                }
              },
              data: [{
                coord: myRegression.points[myRegression.points.length - 1]
              }]
            }
          },
          {
            name: "line",
            type: "line",
            showSymbol: false,
            smooth: true,
            data: myRegression2.points,
            color: ["#940c1b"],
            markPoint: {
              symbol: "circle",
              symbolSize: 1,
              label: {
                show: true,
                position: "left",
                formatter: myRegression2.expression,
                textStyle: {
                  color: "#333",
                  fontSize: 14
                }
              },
              data: [{
                coord: myRegression2.points[myRegression2.points.length - 1]
              }]
            }
          },
          {
            name: "line",
            type: "line",
            showSymbol: false,
            smooth: true,
            data: myRegression3.points,
            color: ["#515b3b"],
            markPoint: {
              symbol: "circle",
              symbolSize: 1,
              label: {
                show: true,
                position: "left",
                formatter: myRegression3.expression,
                textStyle: {
                  color: "#333",
                  fontSize: 14
                }
              },
              data: [{
                coord: myRegression3.points[myRegression3.points.length - 1]
              }]
            }
          },
          {
            name: "scatter1",
            type: "scatter",
            color: ["#515b3b"],
            label: {
              emphasis: {
                show: true
              }
            },
            data: data4,
            xAxisIndex: 1,
            yAxisIndex: 1
          },
          {
            name: "line1",
            type: "line",
            showSymbol: false,
            smooth: true,
            color: ["green"],
            data: myRegression4.points,
            markPoint: {
              symbol: "circle",
              symbolSize: 1,
              label: {
                show: true,
                position: "left",
                formatter: myRegression4.expression,
                textStyle: {
                  color: "#333",
                  fontSize: 14
                }
              },
              data: [{
                coord: myRegression4.points[myRegression4.points.length - 1]
              }]
            },
            xAxisIndex: 1,
            yAxisIndex: 1
          },
          {
            name: "scatter1",
            type: "scatter",
            color: ["blue"],
            label: {
              emphasis: {
                show: true
              }
            },
            data: data5,
            xAxisIndex: 1,
            yAxisIndex: 1
          },
          {
            name: "line1",
            type: "line",
            showSymbol: false,
            smooth: true,
            color: ["red"],
            data: myRegression5.points,
            markPoint: {
              symbol: "circle",
              symbolSize: 1,
              label: {
                show: true,
                position: "left",
                formatter: myRegression5.expression,
                textStyle: {
                  color: "#333",
                  fontSize: 14
                }
              },
              data: [{
                coord: myRegression5.points[myRegression5.points.length - 1]
              }]
            },
            xAxisIndex: 1,
            yAxisIndex: 1
          },
        ]
      };
    }
  };
</script>
<style scoped>

</style>
